import { Component, OnDestroy } from '@angular/core';
import { ProgramDetails } from '../programming-highlights';
import { ActivatedRoute, Router } from '@angular/router';
import { ProgramDetailsService } from '../program-details/program-details.service';
import { LiveBrand } from '../dropdowns/live-brands.service';

@Component({
	template: require('./premiere-details.component.html'),
	selector: 'vcm-premiere-details'
})
export class PremiereDetailsComponent implements OnDestroy {
	programDetails: ProgramDetails = null;
	serviceId: string;
	startDate: string;
	selectedBrand: LiveBrand;
	liveBrands: LiveBrand[] = [];

	constructor(private route: ActivatedRoute,
	            private router: Router,
	            private service: ProgramDetailsService) {}

	ngOnInit() {
		this.route.data.forEach((data: {
			premieresBrands: LiveBrand[],
			programDetails: ProgramDetails
		}) => {
			this.programDetails = data.programDetails;
			this.serviceId = this.service.serviceId;
			this.startDate = this.service.startDate;

			this.liveBrands = data.premieresBrands;
		});
	}

	ngOnDestroy() {
		this.service.clearParams();
	}

	goToPremieresList(selectedBrand?: LiveBrand): void {
		let id = selectedBrand.ServiceId;
		this.router.navigate(['programming', 'premieres', id ? {brand: id} : {}]);
	}

}